import { c as _c } from "react/compiler-runtime";
import { VideoHTMLAttributes } from 'react';
import { useAutoPlayVideoOnVisible } from '@/hooks/useAutoPlayVideoOnVisible';
type BannerVideoProps = VideoHTMLAttributes<HTMLVideoElement>;
function AutoplayVisibleVideo(t0) {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const {
    handleRef
  } = useAutoPlayVideoOnVisible();
  let t1;
  if ($[3] !== children || $[4] !== handleRef || $[5] !== props) {
    t1 = <video {...props} ref={handleRef}>{children}</video>;
    $[3] = children;
    $[4] = handleRef;
    $[5] = props;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
export default AutoplayVisibleVideo;